import React, { Component } from 'react';

import { LoadableComponentErrorBoundaryPage } from './LoadableComponentErrorBoundaryPage';
import { GenericErrorBoundaryPage } from './GenericErrorBoundaryPage';

// Use ErrorBoyndary to catch ChunkLoadError
// https://reactjs.org/docs/error-boundaries.html
class LoadableComponentErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = { error: null };
  }

  static getDerivedStateFromError(error) {
    // Update state so the next render will show the fallback UI.
    return { error };
  }

  render() {
    if (this.state.error && this.state.error.name === 'ChunkLoadError') {
      return <LoadableComponentErrorBoundaryPage />;
    }

    // Any other uncaught render error. Previously fell through to
    // `this.props.children` -- re-rendering the exact same broken tree,
    // which throws again during render and (with no other boundary above
    // this one) takes the whole app blank with zero feedback. Show a
    // generic fallback instead of a silent white screen.
    if (this.state.error) {
      return <GenericErrorBoundaryPage />;
    }

    return this.props.children;
  }
}

// Previously this boundary was skipped entirely in development mode (only
// ChunkLoadError handling was disabled there, to avoid HMR chunk-swap
// error loops) -- but that also meant every OTHER uncaught render error had
// no boundary at all in dev, i.e. exactly the "blank white screen with no
// error" behavior this component now exists to prevent. Always wrap; the
// dev vs prod distinction now lives inside render() via error.name instead.
export default LoadableComponentErrorBoundary;
